<template>
    <div>
        <div id="all">
            <div id="plate">
                <div id="logoHolder">
                    <div id="amCircle" :style="{'background-image':'url(' + require('@/assets/artmuseo.svg')+')'}"></div>
                    <div id="amBand" :style="{'background-image':'url(' + require('@/assets/artmuseo_bandlogo_reg.svg')+')'}"></div>
                </div>
                <div id="arteverywhere" class="band bgWhiteSmoke" :style="{'background-image':'url(' + require('@/assets/images/rmp.png')+')'}">
                    <div id="leftholder">
                    <div id="arteverywhere" class="splash amTeal textcenter">Curate an Artful Life</div>
                    <div id="textbox" class="lighttext amGray textcenter">Artmuseo's primary goal is to invite anyone and everyone to immerse themselves in Art.<br><br> We have created the app so people in all walks of life may enjoy Art in their daily life. Whether they be an artist themself, an art hobbyist, an avid art collector, or social-media influencer, art can open new pathways and reshape the way we interact with one another. <br><br>Art is a powerful tool, we want more people to harness that power to build a wonderful community.
                    </div>
                    </div>
                        <div id="imgright" class="imageBox" :style="{'background-image':'url(' + require('@/assets/images/phone01.png')+')'}"></div>
                </div>
                <div id="mission" class="band bgTeal">
                    <div id="oneholder">
                        <div id="titler" class="splash amWhite textcenter">BETA LICENSE</div>
                        <div id="textbox2" class="regtext amWhite textleft">This Beta Test Agreement (“Agreement”) governs the disclosure of information by Art Museo, Inc., (“Company”) to Beta Testers (the “Recipient”) and Recipient’s use of Company’s beta service offering. 
<br><br>
1. Subject to the terms and conditions of this Agreement, Company grants Recipient a nonexclusive, nontransferable license to use the Company service (“Service”) for a period designated by the Company for the purpose of testing and evaluating the Service. 
<br><br>
2. The Recipient agrees that it will at all times will hold in strict confidence and not disclose Confidential Information (as defined below) to any third party except as approved in writing by the Company and will use the Confidential Information for no purpose other than evaluating the Service. The Recipient shall only permit access to Confidential Information to those of its employees having a need to know and who have signed confidentiality agreements or are otherwise bound by confidentiality obligations at least as restrictive as those contained herein. “Confidential Information” means all non-public materials and information provided or made available by Company to Recipient, including products and services, information regarding technology, know-how, processes, software programs, research, development, financial information and information the Company provides regarding third parties. 
<br><br>
3. The Recipient’s obligations under this Agreement with respect to any portion of the Confidential Information shall terminate when the Recipient can document that: (a) it was in the public domain at the time it was communicated to the Recipient; (b) it entered the public domain subsequent to the time it was communicated to the Recipient through no fault of the Recipient; (c) it was in the Recipient’s possession free of any obligation of confidence at the time it was communicated to the Recipient; (d) it was rightfully communicated to the Recipient free of any obligation of confidence subsequent to the time it was communicated to the Recipient; or (e) it was developed by employees or agents of the Recipient who had no access to any information communicated to the Recipient. After Recipient’s evaluation of the Service is complete, or upon request of the Company, the Recipient shall promptly return to the Company all documents, notes and other tangible materials and return or certify the destruction of all electronic documents, notes, software, data, and other materials in electronic form representing the Confidential Information and all copies thereof. 
<br><br>
4. The Recipient agrees that nothing contained in this Agreement shall be construed as granting any ownership rights to any Confidential Information disclosed pursuant to this Agreement, or to any invention or any patent, copyright, trademark, or other intellectual property right. The Recipient shall not make, have made, use or sell for any purpose any product or other item using, incorporating or derived from any Confidential Information or the Service. The Recipient will not modify, reverse engineer, decompile, create other works from, or disassemble any software programs contained in the Confidential Information or the Service. 
<br><br>
5. This Service is a beta release offering and is not at the level of performance of a commercially available product offering. The Service may not operate correctly and may be substantially modified prior to first commercial release, or at Company’s option may not be released commercially in the future. 
<br><br>
THE SERVICE AND DOCUMENTATION ARE PROVIDED “AS IS” WITHOUT WARRANTY OF ANY KIND, AND COMPANY AND ITS LICENSORS DISCLAIM ALL WARRANTIES, EXPRESS, IMPLIED, OR STATUTORY, INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTIES OF TITLE, NON-INFRINGEMENT OF THIRD PARTY RIGHTS, MERCHANTABILITY, OR FITNESS FOR A PARTICULAR PURPOSE. NO ORAL OR WRITTEN ADVICE OR CONSULTATION GIVEN BY COMPANY, ITS AGENTS OR EMPLOYEES WILL IN ANY WAY GIVE RISE TO A WARRANTY. THE ENTIRE RISK ARISING OUT OF THE USE OR PERFORMANCE OF THE SERVICE REMAINS WITH RECIPIENT. 
<br><br>
6. COMPANY AND ITS LICENSORS SHALL NOT BE LIABLE FOR LOSS OF USE, LOST PROFIT, COST OF COVER, LOSS OF DATA, BUSINESS INTERRUPTION, OR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, SPECIAL, OR EXEMPLARY DAMAGES ARISING OUT OF OR RELATED TO THE SERVICE OR THIS AGREEMENT, HOWEVER CAUSED AND REGARDLESS OF THE FORM OF ACTION, WHETHER IN CONTRACT, TORT (INCLUDING NEGLIGENCE) STRICT LIABILITY, OR OTHERWISE, EVEN IF SUCH PARTIES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT WILL COMPANY’S AGGREGATE CUMULATIVE LIABILITY FOR ANY CLAIMS ARISING OUT OF OR RELATED TO THIS AGREEMENT EXCEED $50.00 OR THE AMOUNT RECIPIENT ACTUALLY PAID COMPANY UNDER THIS AGREEMENT (IF ANY). 
<br><br>
7. The Recipient’s obligations under this Agreement shall survive any termination of this agreement. This Agreement shall be governed by and construed in accordance with the laws of California. The Recipient hereby agrees that breach of this Agreement will cause Company irreparable damage for which recovery of damages would be inadequate, and that the Company shall therefore be entitled to obtain timely injunctive relief under this Agreement, as well as such further relief as may be granted by a court of competent jurisdiction. The Recipient will not assign or transfer any rights or obligations under this Agreement without the prior written consent of the Company. In Witness Whereof, the Recipient has caused this Agreement to be executed as of the date set forth below.
<br><br>
By downloading our Beta Release application you adhere to all the rules listed above.</div>
                    </div>
                </div>
                <div id="footer">
                    <div id="leftholder">
                        <div class="logobox" :style="{'background-image':'url(' + require('@/assets/artmuseo_box.svg')+')'}" ></div>
                        <div id="disclaim" class="smalltext amWhite textcenter">Artmuseo is a trademark of Art Museo, Inc. All Rights Reserved ©2019-2020.<br><br></div>
                    </div>
                    <div id="rightholder">
                        <div class="blank"></div>
                        <div id="signin" class="amWhite textcenter cpointer"><a v-bind:href="artmuseoapp" target="_blank"><span class="amWhite">Artmuseo WebApp</span></a></div>
                        <!-- <div id="signin" class="amWhite textcenter">Investment Inquiries</div> -->
                        <!-- <div id="signin" class="amWhite textcenter">Join our Team | Opportunities</div> -->
                        <div id="signin" class="amWhite textcenter cpointer"><a v-bind:href="policy" target="_blank"><span class="amWhite">Platform Terms & Policies</span></a></div>
                        <!-- <div id="add" class="amWhite textcenter">577 Ofarrell Street | San Francisco CA</div> -->
                        <!-- <div id="signin" class="amWhite textcenter">Contact Us</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import db from '../main'
export default {
    name: "betalicense",
    metaInfo: {
    title: "Artmuseo | Curate an artful life",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale = 1.0,maximum-scale = 1.0, viewport-fit=cover, user-scalable=no", zoom: "fixed"},
      { charset: 'utf8'},
      { property:"og:image", content: "<%= BASE_URL %>ammetaimg.png" },
      { title: 'Artmuseo | Curate an Artful Life' }
    ]
  },
    data(){
        return {
            email: "",
            fullname: "",
            type: "",
            ifSent: false,
            artmuseoapp: 'https://artmuseo.com',
            policy: 'https://artmuseo.com/policy'
        }
    },
    methods: {
        send(){
            if(!this.email){
                return
            }

            if(!this.fullname){
                return
            }
            const sendjoin = db.collection('beta').doc()
            sendjoin.set({email:this.email, fullname: this.fullname, userType: this.type, stat: false, serverTime: new Date(), inviteID: sendjoin.id})
            this.ifSent = true
        }
    }
}
</script>

<style scoped>
/* * {background-color: #00a89d;} */
.cpointer{
    cursor: pointer;
}

a:link {
    text-decoration: none;
}

.blank {
    width: auto;
    height: 70px;
}

@media (max-width: 800px){

        #all {
        width: 100%;
        height: auto;
        background-color: #00a89d;
        }

        #plate {
        width: 100%;
        height: 100%;
        font-family: 'cocomatpro-regular';
        /* color: white; */
        }

        #logoHolder {
        width: 90%;
        height: auto;
        margin-left: 10%;
        margin-right: auto;
        padding-top: 20px;
        /* margin-bottom: 15px; */
        position: relative;
        columns: 2;
        }

        #amCircle {
        width: 50px;
        height: 50px;
        background-position: center;
        background-repeat: no-repeat;
        }

        #amBand {
        width: 200px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        float: right;
        margin-right: 50px;
        }

        #disclaim {
        width: 100%;
        height: auto;
        margin-top: 15px;
        }

        .band {
        width: 100%;
        height: auto;
        padding-left: 10%;
        padding-right: 10%;
        padding-top: 25px;
        padding-bottom: 55px;
        background-position: right bottom;
        background-repeat: no-repeat;
        position: relative;
        overflow: auto;
        }

        .bgWhiteSmoke { background-color: whitesmoke; }
        .bgTeal { background-color: #00a89d; }
        .bgMint { background-color: #A9D9C2; }
        .bgPink { background-color: #E4A39A; }
        .bgGreen { background-color: #1F524E; }
        .bgGray { background-color: gray; }

        #footer {
        width: 100%;
        height:auto;
        background-color: gray;
        padding-left: 15%;
        padding-right: 15%;
        padding-top: 50px;
        padding-bottom: 50px;
        position: relative;
        overflow: auto;
        }


        #imgleft {
        width: 100%;
        height: 230px;
        float: left;
        clear: right;
        margin-right: 5%;
        }

        #imgright {
        width: 100%;
        height: 400px;
        float: right;
        clear: right;
        margin-left:5%;
        /* margin-top: 80px; */
        }

        #imgcenter {
        width: 50px;
        height: 100px;
        margin-left: 42%;
        background-position: center center;
        background-repeat: no-repeat;
        }

        .logobox {
        width: 100%;
        height: 100px;
        /* margin-left: 15%; */
        background-position: center;
        background-repeat: no-repeat;
        }

        .imageBox {
        height: 200px;
        background-color: transparent;
        background-position: center center;
        background-repeat: no-repeat;
        /* position: relative; */
        }

        .image-inner {
        display: block;
        height: 0;
        padding-top: 100%;
        }

        #left45 {
        width: 100%;
        height: auto;
        clear: right;
        float: left;
        }

        #right45 {
        width: 100%;
        height: auto;
        clear: right;
        float: right;
        }

        #leftholder {
        width: 100%;
        height: auto;
        float: left;
        clear: right;
        }

        #oneholder {
        width: 100%;
        height: auto;
        clear: both;
        float: left;
        }

        #centerholder {
        width: 100%;
        height: auto;
        padding-top: 10px;
        /* margin-left: 25%; */
        }

        #rightholder {
        width: 100%;
        height: auto;
        float: right;
        clear: right;
        }

        .textbox {
        width: 100%;
        height: auto;
        float: left;
        clear: right;
        font-family: "cocomatpro-light";
        font-size: 1em;
        color:white;
        line-height: 1em;
        padding: 2%;
        margin-bottom: 10px;
        background-color: transparent;
        border-style: solid;
        border-bottom-color: #00a89d;
        border-top: none;
        border-left: none;
        border-right: none;
        border-width: 2px;
        margin-top: 2%;
        margin-right: 2%;
        }

        .submitBtn {
        width: 30%;
        height: auto;
        padding: 2%;
        background: #A9D9C2;
        font-family: "cocomatpro-regular";
        font-size: 1em;
        margin-left: 35%;
        text-align: center;
        color: white;
        border-style: hidden;
        border-radius: 1vmin;
        float: left;
        clear: right;
        cursor: pointer;
        margin-top: 20px;
        }

        .submitBtn:hover {
        background: rgb(12, 194, 182);
        }


        /* FONTS & HOLDERS */
        .regtext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-regular';
        font-size: 1em;
        line-height: 1.25em;
        }

        .lighttext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: 1em;
        line-height: 1.25em;
        }

        .smalltext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: .65em;
        line-height: 1.em;
        }

        .splash {
        width: auto;
        height: auto;
        font-family: 'cocomatpro-regular';
        background-color: transparent;
        font-size: 1.5em;
        line-height: 1.25em;
        /* text-align: left; */
        position: relative;
        }

            .amWhite {
            color: white;
            }

            .amTeal {
            color: #00a89d;
            }

            .amMint {
            color: #A9D9C2;
            }

            .amGray {
            color: gray
            }

            .amSlate {
            color: slategrey;
            }

            .amGreen {
            color: #1F524E;
            }

            .amPink {
            color: #E4A39A;
            }

            .amGold {
            color: #C9B457;
            }

            .textleft {
            text-align: left;
            }

            .textright {
            text-align: right;
            }

            .textcenter {
            text-align: center;
            }
}

@media (min-width: 801px) and (max-width: 1400px){
        #all {
        width: 100%;
        height: auto;
        background-color: #00a89d;
        }
        #plate {
        width: 100%;
        height: 100vh;
        font-family: 'cocomatpro-regular';
        /* color: white; */
        }

        #logoHolder {
        width: 60%;
        height: auto;
        margin-left: 20%;
        margin-right: auto;
        padding-top: 50px;
        margin-bottom: 50px;
        position: relative;
        columns: 2;
        }

        #amCircle {
        width: 100px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        }

        #amBand {
        width: 250px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        float: right;
        }

        #disclaim {
        width: 100%;
        height: auto;
        margin-top: 15px;
        }

        .band {
        width: 100%;
        height: auto;
        padding-left: 20%;
        padding-right: 20%;
        padding-top: 25px;
        padding-bottom: 55px;
        background-position: right bottom;
        background-repeat: no-repeat;
        position: relative;
        overflow: auto;
        }

        .bgWhiteSmoke { background-color: whitesmoke; }
        .bgTeal { background-color: #00a89d; }
        .bgMint { background-color: #A9D9C2; }
        .bgPink { background-color: #E4A39A; }
        .bgGreen { background-color: #1F524E; }
        .bgGray { background-color: gray; }

        #footer {
        width: 100%;
        height:auto;
        background-color: gray;
        padding-left: 20%;
        padding-right: 20%;
        padding-top: 50px;
        padding-bottom: 50px;
        position: relative;
        overflow: auto;
        }


        #imgleft {
        width: 45%;
        height: 400px;
        float: left;
        clear: right;
        margin-right: 5%;
        }

        #imgright {
        width: 45%;
        height: 400px;
        float: right;
        clear: right;
        margin-left:5%;
        /* margin-top: 80px; */
        }

        #imgcenter {
        width: 50px;
        height: 100px;
        margin-left: 47%;
        background-position: center center;
        background-repeat: no-repeat;
        }

        .logobox {
        width: 100px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        }

        .imageBox {
        height: 400px;
        background-color: transparent;
        background-position: center center;
        background-repeat: no-repeat;
        /* position: relative; */
        }

        .image-inner {
        display: block;
        height: 0;
        padding-top: 100%;
        }

        #left45 {
        width: 45%;
        height: auto;
        clear: right;
        float: left;
        }

        #right45 {
        width: 45%;
        height: auto;
        clear: right;
        float: right;
        }

        #leftholder {
        width: 50%;
        height: auto;
        float: left;
        clear: right;
        }

        #oneholder {
        width: 100%;
        height: auto;
        clear: both;
        float: left;
        }

        #centerholder {
        width: 50%;
        height: auto;
        padding-top: 10px;
        margin-left: 25%;
        }

        #rightholder {
        width: 50%;
        height: auto;
        float: right;
        clear: right;
        }

        .textbox {
        width: 100%;
        height: auto;
        float: left;
        clear: right;
        font-family: "cocomatpro-light";
        font-size: 1em;
        color:white;
        line-height: 1em;
        padding: 2%;
        margin-bottom: 10px;
        background-color: transparent;
        border-style: solid;
        border-bottom-color: #00a89d;
        border-top: none;
        border-left: none;
        border-right: none;
        border-width: 2px;
        margin-top: 2%;
        margin-right: 2%;
        }

        .submitBtn {
        width: 30%;
        height: auto;
        padding: 2%;
        background: #A9D9C2;
        font-family: "cocomatpro-regular";
        font-size: 1em;
        margin-left: 35%;
        text-align: center;
        color: white;
        border-style: hidden;
        border-radius: 1vmin;
        float: left;
        clear: right;
        cursor: pointer;
        margin-top: 20px;
        }

        .submitBtn:hover {
        background: rgb(12, 194, 182);
        }


        /* FONTS & HOLDERS */
        .regtext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-regular';
        font-size: 1em;
        line-height: 1.25em;
        }

        .lighttext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: 1em;
        line-height: 1.25em;
        }

        .smalltext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: .65em;
        line-height: 1.em;
        }

        .splash {
        width: auto;
        height: auto;
        font-family: 'cocomatpro-regular';
        background-color: transparent;
        font-size: 1.75em;
        line-height: 2em;
        /* text-align: left; */
        position: relative;
        }
}

@media (min-width: 1401px){
        #all {
        width: 100%;
        height: auto;
        background-color: #00a89d;
        }
        #plate {
        width: 80%;
        height: auto;
        font-family: 'cocomatpro-regular';
        /* color: white; */
        margin-left: 10%;
        }

        #logoHolder {
        width: 80%;
        height: auto;
        margin-left: 10%;
        margin-right: auto;
        padding-top: 50px;
        margin-bottom: 50px;
        position: relative;
        columns: 2;
        }

        #amCircle {
        width: 100px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        }

        #amBand {
        width: 250px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        float: right;
        }

        #disclaim {
        width: 100%;
        height: auto;
        margin-top: 15px;
        text-align: left;
        }

        .band {
        width: 100%;
        height: auto;
        padding-left: 10%;
        padding-right: 10%;
        padding-top: 25px;
        padding-bottom: 55px;
        background-position: right bottom;
        background-repeat: no-repeat;
        position: relative;
        overflow: auto;
        }

        .bgWhiteSmoke { background-color: whitesmoke; }
        .bgTeal { background-color: #00a89d; }
        .bgMint { background-color: #A9D9C2; }
        .bgPink { background-color: #E4A39A; }
        .bgGreen { background-color: #1F524E; }
        .bgGray { background-color: gray; }

        #footer {
        width: 100%;
        height:auto;
        background-color: gray;
        padding-left: 10%;
        padding-right: 10%;
        padding-top: 50px;
        padding-bottom: 50px;
        position: relative;
        overflow: auto;
        }


        #imgleft {
        width: 45%;
        height: 400px;
        float: left;
        clear: right;
        margin-right: 5%;
        }

        #imgright {
        width: 45%;
        height: 400px;
        float: right;
        clear: right;
        margin-left:5%;
        /* margin-top: 80px; */
        }

        #imgcenter {
        width: 50px;
        height: 100px;
        margin-left: 47%;
        background-position: center center;
        background-repeat: no-repeat;
        }

        .logobox {
        width: 100px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        }

        .imageBox {
        height: 400px;
        background-color: transparent;
        background-position: center center;
        background-repeat: no-repeat;
        /* position: relative; */
        }

        .image-inner {
        display: block;
        height: 0;
        padding-top: 100%;
        }

        #left45 {
        width: 45%;
        height: auto;
        clear: right;
        float: left;
        }

        #right45 {
        width: 45%;
        height: auto;
        clear: right;
        float: right;
        }

        #leftholder {
        width: 50%;
        height: auto;
        float: left;
        clear: right;
        }

        #oneholder {
        width: 100%;
        height: auto;
        clear: both;
        float: left;
        }

        #centerholder {
        width: 50%;
        height: auto;
        padding-top: 10px;
        margin-left: 25%;
        }

        #rightholder {
        width: 50%;
        height: auto;
        float: right;
        clear: right;
        }

        .textbox {
        width: 100%;
        height: auto;
        float: left;
        clear: right;
        font-family: "cocomatpro-light";
        font-size: 1em;
        color:white;
        line-height: 1em;
        padding: 2%;
        margin-bottom: 10px;
        background-color: transparent;
        border-style: solid;
        border-bottom-color: #00a89d;
        border-top: none;
        border-left: none;
        border-right: none;
        border-width: 2px;
        margin-top: 2%;
        margin-right: 2%;
        }

        .submitBtn {
        width: 30%;
        height: auto;
        padding: 2%;
        background: #A9D9C2;
        font-family: "cocomatpro-regular";
        font-size: 1em;
        margin-left: 35%;
        text-align: center;
        color: white;
        border-style: hidden;
        border-radius: 1vmin;
        float: left;
        clear: right;
        cursor: pointer;
        margin-top: 20px;
        }

        .submitBtn:hover {
        background: rgb(12, 194, 182);
        }


        /* FONTS & HOLDERS */
        .regtext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-regular';
        font-size: 1.15em;
        line-height: 1.35em;
        }

        .lighttext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: 1.15em;
        line-height: 1.35em;
        }

        .smalltext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: .65em;
        line-height: 1.em;
        }

        .splash {
        width: auto;
        height: auto;
        font-family: 'cocomatpro-regular';
        background-color: transparent;
        font-size: 1.95em;
        line-height: 2em;
        /* text-align: left; */
        position: relative;
        }
}

.amWhite {
    color: white;
}

.amTeal {
    color: #00a89d;
}

.amMint {
    color: #A9D9C2;
}

.amGray {
    color: gray
}

.amSlate {
    color: slategrey;
}

.amGreen {
    color: #1F524E;
}

.amPink {
    color: #E4A39A;
}

.amGold {
    color: #C9B457;
}

.textleft {
    text-align: left;
}

.textright {
    text-align: right;
}

.textcenter {
    text-align: center;
}

</style>